<template>
  <div style="width: 100%;padding-left: 5%;padding-right: 5%; height: 100%;overflow-y:auto;overflow-x:hidden;">
    <div slot="header">
      <Divider orientation="center">客户分析报告</Divider>
    </div>
    <div id="printBox">
      <reportContent ref="reportContent"></reportContent>
    </div>
  </div>
</template>

<script>

import printJS from 'print-js'
import reportContent from './report-content.vue'
import { setToken } from '../../../libs/util'

export default {
  name: 'custominfo-info',
  components: { reportContent, printJS },
  data () {
    return {
      form: {}
    }
  },
  methods: {
    loadData () {
      if (this.$route.params.token) {
        setToken(this.$route.params.token)
      }
      this.$refs.reportContent.loadData(this.$route.params.id, this.$route.params.token)
      this.$refs.reportContent.setColSpan(24)
    },
    printClick () {
      const style = '@page{size:landscape ; margin: 20mm;} .footer {display: none;} .bottom {margin-top: 30px;}' +
        '.printBtn {display: none;} .printInfoP {font-size: 10px;}' +
        '.printInfo {padding-left: 0px; text-align: left;} .printInfoDiv {display: flex;}' +
        '.printInfoRow { padding-bottom: 3px; flex: 1; }.abc { border-collapse: collapse;}' +
        '.handle {text-align: center;} .handle1 {text-align: right;}'
      printJS({
        printable: 'printBox', // 标签元素id
        type: 'html',
        header: '',
        maxWidth: '2000px',
        targetStyles: ['*'],
        style
      })
    }
  },
  mounted: function () {
    this.loadData()
  }
}
</script>
